import { getSupabaseIdentity, subscribeSupabaseIdentity } from '../hooks/useSupabaseToken'
import { collectionKeyFor, getActiveCollectionKey, setActiveCollectionKey } from './collectionScope'
import { onOwnerStorageReady, ownerStorageReady } from './offline/ownerStorage'

// The active collection cache key follows the ONE shared auth store: a
// permanent signed-in user reads their own account key, a guest (signed out
// or an anonymous session) the guest key, and nothing at all while the auth
// state is unknown. Bound once, when this module is first imported (by
// useCollection and by the collection page).

function scopeKeyFromAuth(): string | null {
  let id: ReturnType<typeof getSupabaseIdentity>
  try {
    id = getSupabaseIdentity()
  } catch {
    // No auth store at all (a test double without it): a guest.
    return collectionKeyFor(null)
  }
  if (id.loading) return null
  const account = id.userId && !id.anonymous ? id.userId : null
  // An account's record lives in the owner's fenced storage once the offline
  // runtime runs: unknown (nothing read) until it is loaded.
  if (account && !ownerStorageReady()) return null
  return collectionKeyFor(account)
}

/** Re-derive the active key from the auth store now. */
export function applyCollectionScopeFromAuth(): void {
  const key = scopeKeyFromAuth()
  if (key !== getActiveCollectionKey()) setActiveCollectionKey(key)
}

if (typeof window !== 'undefined') {
  try {
    subscribeSupabaseIdentity(applyCollectionScopeFromAuth)
  } catch {
    // A test double of the auth store without a subscription: the scope is
    // read once below (and again by the store's test reset).
  }
  applyCollectionScopeFromAuth()
  onOwnerStorageReady(applyCollectionScopeFromAuth)
}
